'use strict'

module.exports=[
  {id:"AED", title:"United Arab Emirates Dirham"},
  {id:"AFN", title:"Afghanistan Afghani"},
  {id:"ALL", title:"Albania Lek"},
  {id:"AMD", title:"Armenia Dram"},
  {id:"ANG", title:"Netherlands Antilles Guilder"},
  {id:"AOA", title:"Angola Kwanza"},
  {id:"ARS", title:"Argentina Peso"},
  {id:"AUD", title:"Australia Dollar"},
  {id:"AWG", title:"Aruba Guilder"},
  {id:"AZN", title:"Azerbaijan Manat"},
  {id:"BAM", title:"Bosnia and Herzegovina Convertible Marka"},
  {id:"BBD", title:"Barbados Dollar"},
  {id:"BDT", title:"Bangladesh Taka"},
  {id:"BGN", title:"Bulgaria Lev"},
  {id:"BHD", title:"Bahrain Dinar"},
  {id:"BIF", title:"Burundi Franc"},
  {id:"BMD", title:"Bermuda Dollar"},
  {id:"BND", title:"Brunei Darussalam Dollar"},
  {id:"BOB", title:"Bolivia Bolíviano"},
  {id:"BRL", title:"Brazil Real"},
  {id:"BSD", title:"Bahamas Dollar"},
  {id:"BTN", title:"Bhutan Ngultrum"},
  {id:"BWP", title:"Botswana Pula"},
  {id:"BYN", title:"Belarus Ruble"},
  {id:"BZD", title:"Belize Dollar"},
  {id:"CAD", title:"Canada Dollar"},
  {id:"CDF", title:"Congo/Kinshasa Franc"},
  {id:"CHF", title:"Switzerland Franc"},
  {id:"CLP", title:"Chile Peso"},
  {id:"CNY", title:"China Yuan Renminbi"},
  {id:"COP", title:"Colombia Peso"},
  {id:"CRC", title:"Costa Rica Colon"},
  {id:"CUC", title:"Cuba Convertible Peso"},
  {id:"CUP", title:"Cuba Peso"},
  {id:"CVE", title:"Cape Verde Escudo"},
  {id:"CZK", title:"Czech Republic Koruna"},
  {id:"DJF", title:"Djibouti Franc"},
  {id:"DKK", title:"Denmark Krone"},
  {id:"DOP", title:"Dominican Republic Peso"},
  {id:"DZD", title:"Algeria Dinar"},
  {id:"EGP", title:"Egypt Pound"},
  {id:"ERN", title:"Eritrea Nakfa"},
  {id:"ETB", title:"Ethiopia Birr"},
  {id:"EUR", title:"Euro Member Countries"},
  {id:"FJD", title:"Fiji Dollar"},
  {id:"FKP", title:"Falkland Islands (Malvinas) Pound"},
  {id:"GBP", title:"United Kingdom Pound"},
  {id:"GEL", title:"Georgia Lari"},
  {id:"GGP", title:"Guernsey Pound"},
  {id:"GHS", title:"Ghana Cedi"},
  {id:"GIP", title:"Gibraltar Pound"},
  {id:"GMD", title:"Gambia Dalasi"},
  {id:"GNF", title:"Guinea Franc"},
  {id:"GTQ", title:"Guatemala Quetzal"},
  {id:"GYD", title:"Guyana Dollar"},
  {id:"HKD", title:"Hong Kong Dollar"},
  {id:"HNL", title:"Honduras Lempira"},
  {id:"HRK", title:"Croatia Kuna"},
  {id:"HTG", title:"Haiti Gourde"},
  {id:"HUF", title:"Hungary Forint"},
  {id:"IDR", title:"Indonesia Rupiah"},
  {id:"ILS", title:"Israel Shekel"},
  {id:"IMP", title:"Isle of Man Pound"},
  {id:"INR", title:"India Rupee"},
  {id:"IQD", title:"Iraq Dinar"},
  {id:"IRR", title:"Iran Rial"},
  {id:"ISK", title:"Iceland Krona"},
  {id:"JEP", title:"Jersey Pound"},
  {id:"JMD", title:"Jamaica Dollar"},
  {id:"JOD", title:"Jordan Dinar"},
  {id:"JPY", title:"Japan Yen"},
  {id:"KES", title:"Kenya Shilling"},
  {id:"KGS", title:"Kyrgyzstan Som"},
  {id:"KHR", title:"Cambodia Riel"},
  {id:"KMF", title:"Comorian Franc"},
  {id:"KPW", title:"Korea (North) Won"},
  {id:"KRW", title:"Korea (South) Won"},
  {id:"KWD", title:"Kuwait Dinar"},
  {id:"KYD", title:"Cayman Islands Dollar"},
  {id:"KZT", title:"Kazakhstan Tenge"},
  {id:"LAK", title:"Laos Kip"},
  {id:"LBP", title:"Lebanon Pound"},
  {id:"LKR", title:"Sri Lanka Rupee"},
  {id:"LRD", title:"Liberia Dollar"},
  {id:"LSL", title:"Lesotho Loti"},
  {id:"LYD", title:"Libya Dinar"},
  {id:"MAD", title:"Morocco Dirham"},
  {id:"MDL", title:"Moldova Leu"},
  {id:"MGA", title:"Madagascar Ariary"},
  {id:"MKD", title:"Macedonia Denar"},
  {id:"MMK", title:"Myanmar (Burma) Kyat"},
  {id:"MNT", title:"Mongolia Tughrik"},
  {id:"MOP", title:"Macau Pataca"},
  {id:"MRU", title:"Mauritania Ouguiya"},
  {id:"MUR", title:"Mauritius Rupee"},
  {id:"MVR", title:"Maldives (Maldive Islands) Rufiyaa"},
  {id:"MWK", title:"Malawi Kwacha"},
  {id:"MXN", title:"Mexico Peso"},
  {id:"MYR", title:"Malaysia Ringgit"},
  {id:"MZN", title:"Mozambique Metical"},
  {id:"NAD", title:"Namibia Dollar"},
  {id:"NGN", title:"Nigeria Naira"},
  {id:"NIO", title:"Nicaragua Cordoba"},
  {id:"NOK", title:"Norway Krone"},
  {id:"NPR", title:"Nepal Rupee"},
  {id:"NZD", title:"New Zealand Dollar"},
  {id:"OMR", title:"Oman Rial"},
  {id:"PAB", title:"Panama Balboa"},
  {id:"PEN", title:"Peru Sol"},
  {id:"PGK", title:"Papua New Guinea Kina"},
  {id:"PHP", title:"Philippines Peso"},
  {id:"PKR", title:"Pakistan Rupee"},
  {id:"PLN", title:"Poland Zloty"},
  {id:"PYG", title:"Paraguay Guarani"},
  {id:"QAR", title:"Qatar Riyal"},
  {id:"RON", title:"Romania Leu"},
  {id:"RSD", title:"Serbia Dinar"},
  {id:"RUB", title:"Russia Ruble"},
  {id:"RWF", title:"Rwanda Franc"},
  {id:"SAR", title:"Saudi Arabia Riyal"},
  {id:"SBD", title:"Solomon Islands Dollar"},
  {id:"SCR", title:"Seychelles Rupee"},
  {id:"SDG", title:"Sudan Pound"},
  {id:"SEK", title:"Sweden Krona"},
  {id:"SGD", title:"Singapore Dollar"},
  {id:"SHP", title:"Saint Helena Pound"},
  {id:"SLL", title:"Sierra Leone Leone"},
  {id:"SOS", title:"Somalia Shilling"},
  {id:"SPL", title:"*Seborga Luigino"},
  {id:"SRD", title:"Suriname Dollar"},
  {id:"STN", title:"São Tomé and Príncipe Dobra"},
  {id:"SVC", title:"El Salvador Colon"},
  {id:"SYP", title:"Syria Pound"},
  {id:"SZL", title:"eSwatini Lilangeni"},
  {id:"THB", title:"Thailand Baht"},
  {id:"TJS", title:"Tajikistan Somoni"},
  {id:"TMT", title:"Turkmenistan Manat"},
  {id:"TND", title:"Tunisia Dinar"},
  {id:"TOP", title:"Tonga Pa'anga"},
  {id:"TRY", title:"Turkey Lira"},
  {id:"TTD", title:"Trinidad and Tobago Dollar"},
  {id:"TVD", title:"Tuvalu Dollar"},
  {id:"TWD", title:"Taiwan New Dollar"},
  {id:"TZS", title:"Tanzania Shilling"},
  {id:"UAH", title:"Ukraine Hryvnia"},
  {id:"UGX", title:"Uganda Shilling"},
  {id:"USD", title:"United States Dollar"},
  {id:"UYU", title:"Uruguay Peso"},
  {id:"UZS", title:"Uzbekistan Som"},
  {id:"VEF", title:"Venezuela Bolívar"},
  {id:"VND", title:"Viet Nam Dong"},
  {id:"VUV", title:"Vanuatu Vatu"},
  {id:"WST", title:"Samoa Tala"},
  {id:"XAF", title:"Communauté Financière Africaine (BEAC) CFA Franc BEAC"},
  {id:"XCD", title:"East Caribbean Dollar"},
  {id:"XDR", title:"International Monetary Fund (IMF) Special Drawing Rights"},
  {id:"XOF", title:"Communauté Financière Africaine (BCEAO) Franc"}
]



// WEBPACK FOOTER //
// ./app/utils/currencies.js